import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'

import CardRepository from '@/shared/http/repositories/crm/card.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'

import RestrictionAlert from '@/components//UI/restrictionAlert/restrictionAlert.vue'
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import DetailContainer from '../detailContainer/detailContainer.vue'
import ModalCardDelete from '@/views/private/crm/details/modal/carddeletemodal.vue'
import ModalCardLost from '@/views/private/crm/details/modal/lost/cardlostmodal.vue'
import ModalCardFinish from '@/views/private/crm/details/modal/finish/cardfinishmodal.vue'
import MoveCardPopover from '../moveCardColumn/moveCardColumn.vue'
import MoveCardBoardPopover from '../moveCardBoard/moveCardBoard.vue'

import InfoPersonModal from '../../details/person/modal/InfoPersonModal.vue'
import CrmDetailsPerson from '../../details/person/person.vue'
import CrmDetailsTimeline from '../../details/timeline/timeline.vue'
import CrmDetailsPhone from '../../details/phones/phone.vue'
import CrmDetailsAddress from '../../details/addresses/address.vue'
import CrmDetailsProduct from '../../details/product/product.vue'
import CrmDetailsInfo from '../../details/info/info.vue'
import CrmDetailsLeadOwner from '../../details/leadowner/leadowner.vue'
import CrmDetailsObservation from '../../details/observation/observation.vue'
import ModalNewFollowUp from '@/views/private/crm/details/followup/followup.vue'
import AssociateRepository from '../../../../../shared/http/repositories/business/associate'
import CrmDetailsCampanha from '@/views/private/crm/details/campanha/CampanhaTable.vue'

// import moment from 'moment'

const cardDataModel = {
  'document': null,
  'boardColumnId': null,
  'motivoPerdaId': null,
  'origemLeadId': null,
  'pessoaId': null,
  'posicao': 0,
  'situacao': 0,
  'countReativado': 0,
  'dataCriacao': null,
  'dataInicioSituacao': null,
  'dataReativacao': null,
  'responsavel': null
}

export default {
  name: 'ModalCard',
  mixins: [ActionsForm],
  props: {
    cardId: {
      type: Number,
      default: null
    },
    boardColumns: {
      type: Array,
      required: false
    },
    isVisita: {
      type: Boolean,
      default: false
    },
    visitaId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      card: null,
      person: null,
      personType: null,
      data: cardDataModel,
      boardArchived: false,
      boardColumnsToReload: [],
      editPersonInfo: false,
      openFollowUpModal: false,
      openMoveCardComponent: false,
      openMoveCardBoardComponent: false,
      isMobile: screen.width <= 480,
      isTablet: screen.width <= 1000
    }
  },
  components: {
    RestrictionAlert,
    DefaultButton,
    DetailContainer,
    CrmDetailsTimeline,
    CrmDetailsPerson,
    CrmDetailsObservation,
    CrmDetailsPhone,
    CrmDetailsAddress,
    CrmDetailsProduct,
    CrmDetailsInfo,
    CrmDetailsLeadOwner,
    InfoPersonModal,
    ModalNewFollowUp,
    ModalCardDelete,
    ModalCardLost,
    ModalCardFinish,
    MoveCardPopover,
    MoveCardBoardPopover,
    CrmDetailsCampanha
  },
  created () {
    this.onLoadLead(this.cardId)
  },
  mounted () {
    this.showModal()
  },
  computed: {
    cardActive () {
      return this.card && this.card.situacao === 'ATIVO' && !this.card.boardColumn.board.arquivado
    }
  },
  methods: {
    // MODAL METHODS
    showModal () {
      this.$refs['modal-crmCard'].show()
    },
    hideModal () {
      // this.clearForms()
      this.$emit('hideModal', 'hideModal')
      this.$refs['modal-crmCard'].hide()
    },
    clearForms () {
      this.boardColumnsToReload = []
      this.selectedOption = null
      this.options = []
      this.cardToRemove = {
        cardId: null,
        boardColumnId: null
      }
      this.data = cardDataModel
      this.card = null
    },
    async onCopy (text) {
      try {
        await navigator.clipboard.writeText(text)
        toast.success('Texto copiado para área de transferência')
      } catch (err) {
        console.error('Failed to copy text to clipboard:', err)
      }
    },
    // LOADS
    onLoadLead () {
      if (this.cardId) {
        CardRepository.GetById(this.cardId)
          .then((response) => {
            if (response.status === 200) {
              this.card = response.data
              // Voltar ao normal após Daniel resolver cards arquivados vindo no requqst
              // this.boardArchived = response.data.boardColumn.board.arquivado
              this.person = response.data.pessoa
              this.personType = this.person.document ? (this.person.document.length === 11 ? 'Pessoa Física' : (this.person.document.length === 14 ? 'Pessoa Jurídica' : null)) : null
              // this.person.dataNascimento ? this.personBornDate = moment(this.person.dataNascimento).format('DD/MM/YY') : ''
              this.onLoadCardSyncDb(this.card)
            }
          })
          .catch((e) => {
            console.log(e.message)
          })
        this.$nextTick(() => {
          this.onReloadFollowup()
        })
      }
    },
    onLoadCardSyncDb (card, newIndex) {
      if (card) {
        this.data.id = card.id
        this.data.boardColumnId = (card.boardColumn ? card.boardColumn.id : null)
        this.data.motivoPerdaId = card.motivoPerda ? card.motivoPerda.id : null
        this.data.posicao = newIndex || card.posicao
        this.data.situacao = card.situacao
        this.data.countReativado = card.countReativado
        this.data.dataCriacao = card.dataCriacao
        this.data.dataInicioSituacao = card.dataInicioSituacao
        this.data.dataReativacao = card.dataReativacao
        this.data.origemLeadId = card.origemLead ? card.origemLead.id : null
        this.data.pessoaId = card.pessoa ? card.pessoa.id : null
      }
    },
    // CUSTOM UPDATES
    closeAndUpdate (idSecondaryBoard) {
      if (idSecondaryBoard) this.boardColumnsToReload.push(idSecondaryBoard)
      if (this.boardColumnsToReload) this.updateBoardColumns()
      this.$nextTick(() => {
        this.hideModal()
      })
    },
    updateBoardColumns () {
      if (!this.boardColumnsToReload.some(column => column === this.card.boardColumn.id)) this.boardColumnsToReload.push(this.card.boardColumn.id)
      this.$emit('reloadBoardColumns', this.boardColumnsToReload)
    },
    updateBoardAndPerson () {
      this.onLoadLead()
      if (this.boardColumnsToReload) this.updateBoardColumns()
      this.onReloadFollowup()
    },
    // MANAGE CRM DETAILS
    openNewFollowUp () {
      this.openFollowUpModal = true
      // this.$refs.ModalNewFollowUp.showModal()
    },
    closeNewFollowUp () {
      this.openFollowUpModal = false
      this.onReloadBoardAndFollowUp()
      // this.onReloadFollowup()
    },
    openEditPerson () {
      this.editPersonInfo = true
    },
    closeEditPerson () {
      this.onLoadLead()
      this.editPersonInfo = false
    },
    openAddObs () {
      this.$refs.CrmDetailsObservation.onAddObs()
    },
    openAddPhone () {
      this.$refs.CrmDetailsPhone.onAddPhone()
    },
    openAddAddress () {
      this.$refs.CrmDetailsAddress.onNewAddress()
    },
    openAddProduct () {
      this.$refs.CrmDetailsProduct.onAddProduct()
    },
    // MOVE CARD THRU COLUMNS
    openMoveCard () {
      this.openMoveCardComponent = true
      this.openMoveCardBoardComponent = false
      // if (!this.isTablet) this.$refs.moveCardPopover.openMoveCard()
    },
    openMoveCardBoard () {
      this.openMoveCardBoardComponent = true
      this.openMoveCardComponent = false
    },
    movedCard (idSecondaryBoard, card, dataInicioSituacao) {
      this.onLoadCardSyncDb(card)
      this.data.dataInicioSituacao = dataInicioSituacao
      this.closeAndUpdate(idSecondaryBoard)
    },
    movedCardBoard (idPrimaryBoardColumn) {
      this.closeAndUpdate(idPrimaryBoardColumn)
    },
    // END CARD
    onGain () {
      if (this.cardId) {
        const gainData = {
          id: this.cardId,
          situacao: 'GANHO',
          dataInicioSituacao: new Date().toISOString()
        }
        CardRepository.PatchSituacao(gainData)
          .then((response) => {
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.closeAndUpdate()
              // this.onLoadLead() // TODO: Nao precisa de reload. O back retorna o objeto alterado
              createNewFollowupWithCard(this.card.pessoa.document, 'sys_oportunidade_ganha', `Definiu o Card de ' + ${this.card.pessoa.nome} + ' como ganho!`, this.ip, this.latitude, this.longitude, this.card.id)
            }
          })
          .catch((e) => {
            if (e.data && e.data.errors.length > 0) {
              if (e.data.errors[0].message && e.data.errors[0].message.match(/produto/)) {
                toast.error(e.data.errors[0].message)
              }
            }
          })
      }
    },
    onLost () {
      this.$refs.ModalCardLost.showModal(this.card)
    },
    onFinish () {
      this.$refs.ModalCardFinish.showModal(this.card)
    },
    onCancel () {
      this.$refs.ModalCardDelete.showModal(this.card)
    },
    // MANAGE FOLLOW-UP
    // CUSTOM LOADS
    onReloadBoardAndFollowUp () {
      this.onReloadFollowup()
      if (this.boardColumnsToReload) this.updateBoardColumns()
    },
    onReloadPersonAndFollowup () {
      this.onReloadFollowup()
      this.onLoadLead()
    },
    onReloadFollowup () {
      if (this.$refs.CrmDetailsTimeline) this.$refs.CrmDetailsTimeline.onLoadAllFollowup()
    },
    onReloadChangeLeadOwner () {
      // WTF LMAO
    },
    async openAssociatePage () {
      let associateId = await this.getAssociateId(this.person.document)

      const routeData = this.$router.resolve({
        name: 'DetalhesAssociate',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
      window.open(routeData.href, '_blank')
      this.$router.resolve(0)
    },
    async getAssociateId (document) {
      if (document) {
        let id = null
        await AssociateRepository.GetByDocument(document)
          .then(response => {
            id = response.data.content[0].id
          })
        return id
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/components/modalCard/modalCard.js